import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';

// Lazy-load pages that pull in heavy deps (Three.js, SceneViewer360) so they don't
// block the main bundle or cause initialisation errors on the landing page.
const PlayConsole = lazy(() => import('./pages/PlayConsole'));
const Explorer = lazy(() => import('./pages/Explorer'));
const MCC = lazy(() => import('./pages/MCC'));

function LazyFallback() {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', background: '#020806', color: '#5dff9c',
      fontFamily: "'JetBrains Mono', monospace", fontSize: '0.9rem',
    }}>
      ▓ Loading module…
    </div>
  );
}

function App() {
  return (
    <div className="App hud-scanlines">
      <BrowserRouter>
        <Suspense fallback={<LazyFallback />}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/play" element={<PlayConsole />} />
            <Route path="/map" element={<Explorer />} />
            <Route path="/mcc" element={<MCC />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
